<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 5C2.5 4.44771 2.94771 4 3.5 4H20.5C21.0523 4 21.5 4.44771 21.5 5V19C21.5 19.5523 21.0523 20 20.5 20H3.5C2.94771 20 2.5 19.5523 2.5 19V5Z"
      stroke="#696D69"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.25 9C7.6642 9 8 8.6642 8 8.25C8 7.8358 7.6642 7.5 7.25 7.5C6.8358 7.5 6.5 7.8358 6.5 8.25C6.5 8.6642 6.8358 9 7.25 9Z"
      stroke="#696D69"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 12L10 14L13 10.5L21.5 17V19C21.5 19.5523 21.0523 20 20.5 20H3.5C2.94771 20 2.5 19.5523 2.5 19V17L7.5 12Z"
      fill="#696D69"
      stroke="#696D69"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
</template>
